/**
 * TeacherStatePage — route wrapper at /teacher/state. Pulls the
 * teacher id from the auth context and renders the panel.
 *
 * The students list is a placeholder until Phase 4 (#9) or a future
 * "students this teacher has scope to observe" backend ships. For now,
 * Phase 2 demonstrates the panel works against AG-UI with a synthetic
 * roster — admins can verify the streaming + state reduction flow
 * even without a real students-by-teacher API. Real data wires in
 * later without changing the panel's public interface.
 */
import { useAuth } from "@/auth/OidcProvider";
import { TeacherStudentStatePanel } from "./TeacherStudentStatePanel";

// Placeholder roster — replaced by a real query once a students-by-teacher
// API is available. Until then, an admin testing the panel can swap real
// student UUIDs in here.
const PLACEHOLDER_STUDENTS = [
  { id: "11111111-1111-1111-1111-111111111111", displayName: "Student A (placeholder)" },
  { id: "22222222-2222-2222-2222-222222222222", displayName: "Student B (placeholder)" },
];

export default function TeacherStatePage() {
  const { state } = useAuth();
  if (state.status !== "authenticated") {
    return <p className="text-slate-500">Signing in…</p>;
  }
  return (
    <TeacherStudentStatePanel
      teacherId={state.user.id}
      students={PLACEHOLDER_STUDENTS}
    />
  );
}
